import React from 'react';
import { Box, Grid, Typography, List, ListItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import img from './img/shared-inboxImage.png';

const CustomerSection = () => {
    return (
        <>
            {/* Transparent HR Tag with Blur Effect */}
            <Divider
                sx={{
                    borderColor: 'text.secondary',
                    opacity: 0.3, // Make it semi-transparent
                    backdropFilter: 'blur(5px)', // blur effect
                    WebkitBackdropFilter: 'blur(5px)', // For browser compatibility
                    mb: 4, // Margin below the divider
                    width: '100%',
                }}
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, #e3f2fd, #ffffff)',
                }}
            >
                <Box
                    sx={{
                        padding: { xs: 3, sm: 4, md: 6 },
                        minHeight: { xs: 'auto', md: '85vh' },
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: { xl: "74%", lg: "90%", md: "90%", sm: "90%" },
                    }}
                >

                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 'bold',
                            fontSize: { xs: '28px', sm: '36px', md: '40px' },
                            color: '#1A1A3D',
                            textAlign: { xs: 'center', md: 'left' },
                            mb: 4,
                            width:'100%',
                        }}
                    >
                        Shared inbox for collaborative customer support
                    </Typography>

                    {/* Two-column layout using Grid */}
                    <Grid
                        container spacing={4}
                        alignItems="center"
                    >
                        {/* Left Column: Heading and Features List */}
                        <Grid
                            item
                            xs={12}
                            md={6}
                            sx={{
                                paddingLeft: { xs: 2, md: 4 },
                                paddingRight: { xs: 2, md: 4 },
                                order: { xs: 2, md: 1 },  
                            }}
                        >
                            <List>
                                {[
                                    'One collaborative inbox for your entire team',
                                    'Automatic conversation assignment for faster resolutions',
                                    'Internal notes and tags for smoother team collaboration',
                                    'Conversation history to access the full customer context.',
                                ].map((text, index) => (
                                    <ListItem key={index} sx={{ padding: 0, mb: 2 }}>
                                        <ListItemIcon>
                                            <CheckCircleOutlineIcon sx={{ color: '#4A90E2', fontSize: { xs: '24px', md: '28px' } }} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={text}
                                            primaryTypographyProps={{
                                                variant: 'body1',
                                                fontSize: { xs: '16px', sm: '18px', md: '20px' },
                                                color: '#1A1A3D',
                                                fontWeight: 'medium',
                                            }}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>

                        {/* Right Column: Image */}
                        <Grid
                            item
                            xs={12}
                            md={6}
                            sx={{
                                paddingLeft: { xs: 2, md: 4 },
                                paddingRight: { xs: 2, md: 4 },
                                order: { xs: 1, md: 2 },  
                            }}
                        >
                            <Box
                                component="img"
                                src={img}
                                alt="Collaborative Chat Interface"
                                sx={{
                                    width: { xs: '100%', md: '90%' },
                                    height: 'auto',
                                    borderRadius: 2,
                                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                    objectFit: 'contain',
                                    display: 'block',
                                    margin: '0 auto',
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>

        </>
    );
};

export default CustomerSection;